import React, { } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  ExcelExport,
  Search,
} from '@syncfusion/ej2-react-grids';

const InventoryContent = ({ dt }) => {
  const toolbarOptions = ['Search', 'ExcelExport'];
  const numericSortComparer = (reference, comparer) => {
    const numReference = parseFloat(reference);
    const numComparer = parseFloat(comparer);

    if (numReference < numComparer) {
      return -1;
    }
    if (numReference > numComparer) {
      return 1;
    }
    return 0;
  };
  let gridInstance;

  const toolbarClick = (args) => {
    if (args.item.text === 'Excel Export') { // 'Grid_excelexport' is the default ID for the Excel export button
      const properties = {
        fileName: `ExcelExport_MSN_BandID_${dt[0].organization}_${new Date().toISOString()}.xlsx`,
      };

      gridInstance.excelExport(properties);
    }
  };

  return (
    <GridComponent
      ref={(g) => { gridInstance = g; }}
      dataSource={dt}
      toolbar={toolbarOptions}
      toolbarClick={toolbarClick}
      allowPaging
      allowSorting
      allowExcelExport
    >
      <ColumnsDirective>
        <ColumnDirective
          field="device"
          headerText="Device"
          width="150"
        />
        <ColumnDirective
          field="msn"
          headerText="MSN"
          width="150"
        />
        <ColumnDirective
          field="bandId"
          headerText="Band ID"
          width="150"
          sortComparer={numericSortComparer}
        />
      </ColumnsDirective>
      <Inject services={[Search, ExcelExport]} />
    </GridComponent>

  );
};
export default InventoryContent;
